import { render, staticRenderFns } from "./indexdel3.vue?vue&type=template&id=6a948be3&scoped=true&"
import script from "./indexdel3.vue?vue&type=script&lang=js&"
export * from "./indexdel3.vue?vue&type=script&lang=js&"
import style0 from "./indexdel3.vue?vue&type=style&index=0&id=6a948be3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a948be3",
  null
  
)

export default component.exports